import "./list.scss";

export var listComponentCss = {
  root: "svc-list__container",
  itemsContainer: "svc-list",
  itemsContainerFiltering: "svc-list--filtering",
  emptyContainer: "svc-list__empty-container",
  emptyText: "svc-list__empty-text",

  filter: "svc-list__filter",
  filterIcon: "svc-list__filter-icon",
  filterInput: "svc-list__input",
  searchClearButtonIcon: "svc-list__filter-clear-button",

  loadingIndicator: "svc-list__loading-indicator",
  item: "svc-list__item",
  itemSelected: "svc-list__item--selected",
  itemGroup: "svc-list__item--group",
  itemGroupSelected: "svc-list__item--group-selected",
  itemWithIcon: "svc-list__item--with-icon",
  itemDisabled: "svc-list__item--disabled",
  itemFocused: "svc-list__item--focused",
  itemHovered: "svc-list__item--hovered",
  itemTextWrap: "svc-list__item-text--wrap",
  itemIcon: "svc-list__item-icon",
  itemMarkerIcon: "svc-list-item__marker-icon",
  itemSeparator: "svc-list__item-separator",
  itemBody: "svc-list__item-body",
};
